import React, { useState, useEffect } from 'react';

import {
  Typography,
  Box,
  Autocomplete,
  TextField,
  Button,
  IconButton,
} from '@mui/material';
import { keyframes } from '@emotion/react';
import SimpleMap from '../../components/Map/SimpleMap';
import { Select as SelectInt } from '../../components/Select';
import PlanLoading from '../../components/icons/PlanLoading';
import { LoadingSpinnerIcon } from '../../components/icons/LoadingSpinnerIcon';
import toast from 'react-hot-toast';
import { RefreshIcon } from '../../components/icons/RefreshIcon';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import axios from 'axios';

const specialtyDescriptions: Record<string, string> = {
  Todos: 'Atende todas as especialidades.',

  Cirurgia:
    'Realiza pequenas cirurgias e a remoção de dentes, inclusive sisos.',

  'Clínica geral':
    ' Realiza todos os tipos de tratamentos odontológicos, em geral: limpeza, restaurações, extrações.',

  Ortodontia: 'Trata o alinhamento dos dentes e correções da mordida.',

  Endodontia: 'Realiza tratamento e retratamento de canais dos dentes.',

  Periodontia:
    'Realiza a prevenção e o tratamento das doenças da gengiva e do osso de suporte dos dentes.',

  Urgência:
    'São aqueles que necessitam de atendimento imediato e podem ser realizados em Pronto Socorro Odontológico (exemplos: hemorragia, dor intensa, recolocação de próteses, entre outros).',

  Odontopediatria:
    'Realiza todos os tratamentos em bebês e crianças até 12 anos  de idade.',

  Radiologia:
    'Realiza os exames de diagnóstico através das radiografias odontológicas (Raio-x).',

  Prótese:
    'Realiza tratamento com proteses dentárias :  bloco, coroa, ponte fixa e dentadura.',

  'Cirurgia Bucomaxilofacial':
    'Realiza cirurgias ósseas e bucais , biópsias, remoção de dentes, inclusive inclusos (dentro do osso) e cirurgias em geral.',

  Prevenção: 'Realiza limpezas simples e aplicação de flúor.',

  'Clínica Radiologia / Radiologia':
    'Realiza os exames de imagem através das radiografias odontológicas (Raio-x), fotos e documentações ortodônticas.',

  Dentística:
    'Realiza restaurações de dentes cariados, desgastados ou fraturados (obturações).',

  Diagnostico:
    'Realiza avaliação para detectar problemas bucais e planejar o tratamento.',

  Implante: 'Realiza cirurgias para a colocação de implantes dentários.',

  'Teste e exame de laboratório': 'Realiza testes da  saliva.',

  'Urgência Diurna':
    'Realiza atendimentos em casos de dor intensa , hemorragia, recolocação de próteses,  curativos entre outros.',

  'Urgência noturna':
    'Realiza atendimentos em casos de dor intensa , hemorragia, recolocação de próteses, curativos entre outros (Atendimento 24 horas).',
};

const options = Object.entries(specialtyDescriptions).map(([key, desc]) => ({
  label: key.charAt(0).toUpperCase() + key.slice(1),
  description: desc,
  value: key,
}));

const Pesquisa: React.FC = () => {
  const [isSearchDone, setIsSearchDone] = useState(false);
  const [isPesquisaFeita, setIsPesquisaFeita] = useState(false);
  const [clinicas, setClinicas] = useState<any[]>([]);
  const [bairros, setBairros] = useState<any[]>([]);
  const [location, setLocation] = useState('');
  const [loading, setLoading] = useState(false);
  const [answers, setAnswers] = useState<Record<number, boolean>>({});
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [results, setResults] = useState<
    Array<{
      cnpj: string;
      telefone: any;
      endereco: any;
      longitude: any;
      latitude: any;
      nome: string;
      especialidade: string;
      local: string;
      razaoSocial: string;
      municipio: string;
      uf: string;
      cep: string;
      qualiss: any[];
    }>
  >([]);
  const [resolvedAddress, setResolvedAddress] = useState('');
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [especialidade, setSpeciality] = useState<number>(44);
  const [selectedUF, setSelectedUF] = useState<string>('');
  const [selectedCity, setSelectedCity] = useState<string>('');
  const [selectedBairro, setSelectedBairro] = useState<string>('');
  const [estados, setEstados] = useState<any>([]);
  const [focusedMarkerId, setFocusedMarkerId] = useState<string | null>(null);
  const [mapCenter, setMapCenter] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  const [open, setOpen] = useState(false);
  const [produtos, setProdutos] = useState([]);
  const [indiceDentistaSelecionado, setIndiceDentistaSelecionado] = useState<
    number | null
  >(null);

  const url = process.env.REACT_APP_URL_BASE;
  const token = process.env.REACT_APP_TOKEN_S4E_V2;

  const [specialty, setSpecialty] = useState<{
    label: string;
    description: string;
    value: string;
  } | null>(null);

  useEffect(() => {
    if (selectedUF) {
      getCity(selectedUF);
    }
  }, [selectedUF]);

  const isCepMode = location.trim().length > 0;
  const isRegionMode = selectedUF || selectedCity || selectedBairro;

  const questions = [
    {
      id: 1,
      text: 'A consulta é para você?',
      specialtyHint: null,
    },
    {
      id: 2,
      text: 'Está com dor de dente, sensibilidade ou desconforto forte?',
      specialtyHint: 'diagnostico',
      Idespecialidade: 2,
    },
    {
      id: 3,
      text: 'Percebe dentes tortos ou desalinhados, ou sente incômodo ao morder?',
      specialtyHint: 'ortodontia',
      Idespecialidade: 2,
    },
    {
      id: 4,
      text: 'Notou sangramento na gengiva, inchaço ou mau hálito frequente?',
      specialtyHint: 'periodontia',
      Idespecialidade: 5,
    },
    {
      id: 5,
      text: 'Você ou seu(sua) filho(a) tem menos de 13 anos?',
      specialtyHint: 'odontopediatria',
      Idespecialidade: 3,
    },
    {
      id: 6,
      text: 'Está com prótese solta, falta de dente ou dente quebrado?',
      specialtyHint: 'prótese',
      Idespecialidade: 7,
    },
    {
      id: 7,
      text: 'Já fez ou precisa fazer radiografia odontológica?',
      specialtyHint: 'clinica radiologica / radiologia',
      Idespecialidade: 11,
    },
    {
      id: 8,
      text: 'A consulta é para alguém com necessidades especiais (ex: autismo, paralisia cerebral)?',
      specialtyHint: 'clínico geral',
      Idespecialidade: 9,
    },
    {
      id: 9,
      text: 'Está com dor urgente, sangramento intenso ou sofreu algum trauma?',
      specialtyHint: 'urgência diurna',
      Idespecialidade: 9,
    },
    {
      id: 10,
      text: 'Precisa remover um dente, siso ou fazer alguma cirurgia bucal?',
      specialtyHint: 'cirurgia buco maxilo facial',
      Idespecialidade: 32,
    },
    {
      id: 11,
      text: 'Quer apenas uma avaliação geral da sua saúde bucal?',
      specialtyHint: 'clínico geral',
      Idespecialidade: 44,
    },
  ];

  const handleAnswer = (value: boolean) => {
    const id = questions[currentQuestion].id;
    setAnswers(prev => ({ ...prev, [id]: value }));
    setCurrentQuestion(prev => prev + 1);
  };

  const getSuggestedSpecialty = () => {
    const priorityOrder = [
      'Todos',
      'urgência diurna',
      'urgência noturna',
      'cirurgia bucomaxilofacial',
      'endodontia',
      'periodontia',
      'ortodontia',
      'prótese',
      'clinica radiologica / radiologia',
      'odontopediatria',
      'diagnostico',
      'clínico geral',
    ];

    for (const specialty of priorityOrder) {
      const match = questions.find(
        q => q.specialtyHint === specialty && answers[q.id],
      );
      if (match) {
        return {
          especialidade: specialty,
          id: match.Idespecialidade,
        };
      }
    }

    return {
      especialidade: 'clínico geral',
      id: 44,
    };
  };

  useEffect(() => {
    getUfs();
  }, []);

  const getUfs = async () => {
    try {
      const response = await axios.get(
        `${url}/api/redeatendimento/UFs?token=${token}`,
      );
      setEstados(response.data.dados.filter((uf: any) => uf.Id !== 0));
    } catch (error) {
      return [];
    }
  };

  const getCity = async (uf: string) => {
    try {
      const response = await axios.get(
        `${url}/api/redeatendimento/Municipios?token=${token}&ufID=${uf}&apenasRedeCredenciada=1`,
      );
      setCity(response.data.dados);
    } catch (error) {
      return [];
    }
  };

  const getEndereco = async (cep: string) => {
    try {
      const response = await axios.post(
        `${url}/api/redeatendimento/Endereco?token=${token}&cep=${cep}`,
      );
      const data = response.data.dados;

      if (!data || !data.IdUf || !data.IdMunicipio) {
        toast.error('CEP não localizado. Verifique e tente novamente.');
        return;
      }

      const fullAddress = `${data.Logradouro}, ${data.Bairro}, ${data.Municipio} - ${data.Uf}`;
      setResolvedAddress(fullAddress);
      setSelectedUF(data.IdUf);
      setSelectedCity(data.IdMunicipio);
      setSelectedBairro(data.IdBairro);
    } catch (error) {
      console.error('Erro ao buscar Cep:', error);
      toast.error('Erro ao buscar endereço. Verifique o CEP informado.');
    }
  };

  useEffect(() => {
    if (currentQuestion >= questions.length) {
      const suggested = getSuggestedSpecialty();
      const matchedOption = options.find(
        opt =>
          opt.value.toLowerCase() === suggested.especialidade.toLowerCase(),
      );

      setSpecialty(matchedOption || null);
      setSpeciality(suggested.id);
    }
  }, [currentQuestion]);

  const handleSearch = async () => {
    if (
      !(location || (selectedUF && selectedCity && selectedBairro)) ||
      !specialty
    ) {
      toast.error('Preencha a localização e selecione a especialidade');
      return;
    }

    setLoading(true);

    if (!city || !state || !specialty) return;

    try {
      const url = `${process.env.REACT_APP_OG_API_URL}/info/RedeVendas?ufId=${selectedUF}&municipioId=${selectedCity}&especialidadeId=${especialidade}&bairro=${selectedBairro}&quantidade=5`;
      const res = await fetch(url);
      const data = await res.json();
      const clinicasRecebidas = Array.isArray(data)
        ? data
        : data.clinicas ?? [data];

      setClinicas(clinicasRecebidas);

      const resultado = clinicasRecebidas.map(clinica => ({
        nome: clinica.nomeFantasia,
        especialidade:
          clinica.dentistas?.[0]?.especialidades ?? 'Não informado',
        local: clinica.bairro?.trim() ?? '',
        latitude: parseFloat(clinica.latitude?.replace(',', '.') ?? '0'),
        longitude: parseFloat(clinica.longitude?.replace(',', '.') ?? '0'),
        endereco: clinica.endereco ?? '',
        telefone: clinica.telefone ?? '',
        razaoSocial: clinica.razaoSocial ?? '',
        uf: clinica.uf ?? '',
        municipio: clinica.municipio ?? '',
        cnpj: clinica.cnpj ?? clinica.cpnj ?? '',
        cep: clinica.cep ?? '',
        qualiss: clinica.dentistas?.[0]?.qualiss || [],
      }));

      if (resultado.length === 0) {
        toast.error(
          'Nenhuma clínica encontrada nessa região. Tente novamente.',
        );
        resetInterface();
        return;
      }

      setIsPesquisaFeita(true);
      setIsSearchDone(true);
      setResults(resultado);
      toast.success('Resultados carregados com sucesso!');
    } catch (error) {
      toast.error('Erro ao buscar dados. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  let debounceTimer: NodeJS.Timeout;
  useEffect(() => {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      const query = location.trim();
      const cep = query.replace(/\D/g, '');

      if (cep.length === 8) {
        getEndereco(cep);
      } else if (query.length > 3) {
        const parts = query.split(' ');
        const possibleUF = parts[parts.length - 1].toUpperCase();
        const cidade = parts.slice(0, parts.length - 1).join(' ');

        if (cidade.length > 2 && possibleUF.length === 2) {
          setResolvedAddress(`${cidade} - ${possibleUF}`);
        } else {
          setResolvedAddress('');
        }
      } else {
        setResolvedAddress('');
      }
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [location]);

  const handleSetMapFocus = (dentista: any) => {
    setFocusedMarkerId(String(results.indexOf(dentista)));
    setMapCenter({ lat: dentista.latitude, lng: dentista.longitude });
  };

  const handleRefresh = async () => {
    if (!selectedUF || !selectedCity || !especialidade) {
      return;
    }
    setIsRefreshing(true);

    try {
      const url = `${process.env.REACT_APP_OG_API_URL}/info/RedeVendas?ufId=${selectedUF}&municipioId=${selectedCity}&especialidadeId=${especialidade}&bairro=${selectedBairro}&quantidade=5`;

      const res = await fetch(url);
      const data = await res.json();

      const clinicas = Array.isArray(data) ? data : data.clinicas ?? [];

      const resultado = clinicas.map(clinica => ({
        nome: clinica.nomeFantasia,
        especialidade:
          clinica.dentistas?.[0]?.especialidades ?? 'Não informado',
        local: clinica.bairro?.trim() ?? '',
        latitude: parseFloat(clinica.latitude?.replace(',', '.') ?? '0'),
        longitude: parseFloat(clinica.longitude?.replace(',', '.') ?? '0'),
        endereco: clinica.endereco ?? '',
        telefone: clinica.telefone ?? '',
        razaoSocial: clinica.razaoSocial ?? 'Não informado',
        uf: clinica.uf ?? '',
        municipio: clinica.municipio ?? '',
        cnpj: clinica.cnpj ?? clinica.cpnj ?? '', //condicionado ao retorno da api seria cnpj ou cpnj
        cep: clinica.cep ?? '',
        qualiss: clinica.dentistas?.[0]?.qualiss || [],
      }));

      setResults(resultado);
      toast.success('Lista atualizada com sucesso!');
    } catch (err) {
      toast.error('Erro ao atualizar a lista de dentistas.');
    } finally {
      setTimeout(() => setIsRefreshing(false), 1000);
    }
  };

  const getBairros = async (municipioId: string) => {
    try {
      const response = await axios.get(
        `${url}/api/redeatendimento/Bairros?token=${token}&municipioId=${municipioId}&apenasRede=1`,
      );
      setBairros(response.data.dados);
    } catch (error) {
      //console.log('Erro ao buscar bairros:', error);
    }
  };

  useEffect(() => {
    if (selectedCity) {
      getBairros(selectedCity);
    }
  }, [selectedCity]);

  const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(33, 150, 243, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0);
  }
`;

  const resetInterface = () => {
    setIsSearchDone(false);
    setIsPesquisaFeita(false);
    setClinicas([]);
    setResults([]);
    setLocation('');
    setSelectedUF('');
    setSelectedCity('');
    setSelectedBairro('');
    setResolvedAddress('');
    setSpecialty(null);
    setSpeciality(44);
    setCurrentQuestion(0);
    setAnswers({});
  };

  const handleOpenUber = (lat, lng) => {
    const uberAppUrl = `uber://?action=setPickup&dropoff[latitude]=${lat}&dropoff[longitude]=${lng}`;
    const uberWebUrl = `https://m.uber.com/ul/?action=setPickup&dropoff[latitude]=${lat}&dropoff[longitude]=${lng}`;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      window.location.href = uberAppUrl;
      setTimeout(() => {
        window.location.href = uberWebUrl;
      }, 1000);
    } else {
      window.open(uberWebUrl, '_blank');
    }
  };

  const handleOpenWaze = (lat: number, lng: number) => {
    const wazeUrl = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
    window.open(wazeUrl, '_blank');
  };

  const dentistaSelecionado =
    indiceDentistaSelecionado !== null
      ? results[indiceDentistaSelecionado]
      : results[0];

  useEffect(() => {
    const urlBaseV1 = process.env.REACT_APP_URL_BASE;
    const apiUrl = urlBaseV1.endsWith('/')
      ? `${urlBaseV1}api/ClassificacaoAns/Buscar?token=${token}`
      : `${urlBaseV1}/api/ClassificacaoAns/Buscar?token=${token}`;

    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        setProdutos(Array.isArray(data.dados) ? data.dados : []);
      })
      .catch(err => console.error('Erro ao buscar produtos:', err));
  }, [open]);

  const mapTipoContratacao = {
    2: 'COLETIVO EMPRESARIAL',
    3: 'INDIVIDUAL OU FAMILIAR',
    8: 'COLETIVO POR ADESÃO',
  };

  const mapAbrangencia = {
    1: 'NACIONAL',
    4: 'GRUPO DE ESTADOS',
  };

  const mapStatus = {
    1: 'ATIVO',
    0: 'INATIVO',
  };

  const letraIcones: Record<string, string> = {
    N: '/assets/images/legenda-ans-letras/N.png',
    P: '/assets/images/legenda-ans-letras/P.png',
    Q: '/assets/images/legenda-ans-letras/Q.png',
    R: '/assets/images/legenda-ans-letras/R.png',
    A: '/assets/images/legenda-ans-letras/A.png',
    D: '/assets/images/legenda-ans-letras/D.png',
    E: '/assets/images/legenda-ans-letras/E.png',
    G: '/assets/images/legenda-ans-letras/G.png',
    I: '/assets/images/legenda-ans-letras/I.png',
    M: '/assets/images/legenda-ans-letras/M.png',
  };

  function getLetraEspecialidade(q: any): string | null {
    if (q.Descricao?.toUpperCase().includes('ESPECIALISTA')) return 'E';
    return null;
  }

  function formatarCNPJ(cnpj: string): string {
    const cnpjLimpo = cnpj.replace(/\D/g, '');
    if (cnpjLimpo.length !== 14) return cnpj;
    return cnpjLimpo.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5',
    );
  }

  return (
    <div className="bg-white shadow-sm p-6 rounded-2xl border mt-6 max-w-7xl border-gray-200 space-y-4 mx-auto">
      <div className="bg-blue-5 rounded-sm mt-10">
        <h2 className="text-xl p-8 font-bold text-blue-900 flex items-center gap-2">
          <span role="img" aria-label="search" title="Busca por dentista">
            🔍
          </span>
          Buscar Dentistas
        </h2>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
        <div className="bg-gray-100 p-4 rounded-md flex flex-col gap-3">
          <p className="text-1xl sm:text-base text-blue-900 font-semibold">
            Responda o assistente abaixo e obtenha a especialidade que precisa:
          </p>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
            <div
              className="bg-blue-600 h-2 rounded-full transition-all duration-300 ease-in-out"
              style={{
                width: `${(currentQuestion / questions.length) * 100}%`,
              }}
            ></div>
          </div>

          {currentQuestion < questions.length ? (
            <div className="bg-blue-50 border border-blue-200 p-4 rounded-xl shadow-sm transition hover:shadow-md">
              <p className="text-blue-800 font-medium">
                {questions[currentQuestion].text}
              </p>
              <div className="flex gap-3 py-2">
                <button
                  onClick={() => handleAnswer(true)}
                  className="bg-green-300 border  hover:bg-green-400 border-blue-200 p-4 rounded-xl shadow-sm transition hover:shadow-md"
                >
                  <span role="img" aria-label="icone" title="icone de sim">
                    👍 Sim
                  </span>
                </button>
                {currentQuestion > 0 && (
                  <button onClick={() => setCurrentQuestion(prev => prev - 1)}>
                    <ArrowLeft className="inline mr-1" />
                    <span className="text-blue-700">Voltar</span>
                  </button>
                )}
                <button
                  onClick={() => handleAnswer(false)}
                  className="bg-red-600 hover:bg-red-700 text-white px-4 py-1 rounded-xl"
                >
                  <span role="img" aria-label="icone" title="Icone de não">
                    👎 Não
                  </span>
                </button>
                <p className="text-sm text-gray-500">
                  Pergunta {currentQuestion + 1} de {questions.length}
                </p>
              </div>
            </div>
          ) : (
            <div className="mt-4 text-sm text-gray-700">
              <strong>Especialidade recomendada:</strong>{' '}
              <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold inline-block">
                {getSuggestedSpecialty().especialidade}
              </span>
            </div>
          )}
        </div>

        <Box p={2} bgcolor="#f7f7f7" color="primary" borderRadius={2}>
          <Typography fontWeight="bold" color="primary" mb={1}>
            Escolha uma especialidade abaixo
          </Typography>

          <Autocomplete
            options={options}
            getOptionLabel={option => option.label}
            value={specialty}
            onChange={(_, newValue) => setSpecialty(newValue)}
            renderOption={(props, option) => (
              <Box
                component="li"
                {...props}
                sx={{ flexDirection: 'column', alignItems: 'flex-start' }}
              >
                <Typography fontWeight="bold" color="primary">
                  {option.label}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {option.description}
                </Typography>
              </Box>
            )}
            renderInput={params => (
              <TextField {...params} label="Especialidade" variant="outlined" />
            )}
          />

          <Typography
            variant="caption"
            color="error"
            sx={{ marginTop: '4px', display: 'block' }}
          >
            * Campo obrigatório para buscar dentistas
          </Typography>

          {specialty && (
            <Box mt={2} p={2} bgcolor="#f7f7f7" borderRadius={2}>
              <Typography variant="subtitle1" fontWeight="bold" color="primary">
                {specialty.label}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {specialty.description}
              </Typography>
            </Box>
          )}
        </Box>
      </div>

      <div className="display-flex justify-between p-5 mt-5 ">
        <div className="mt-6 grid md:grid-cols-2 gap-4 items-center">
          <div>
            <label className="flex text-sm text-blue-700 font-semibold mb-1">
              Onde você deseja ser atendido?
            </label>
            <input
              type="text"
              placeholder="Digite seu CEP"
              value={location}
              onChange={e => setLocation(e.target.value)}
              disabled={!!isRegionMode}
              className="p-2 border-b w-1/2  border-blue-500 outline-none"
            />
          </div>
          {resolvedAddress && (
            <p className="text-sm text-blue-600 mt-1">{resolvedAddress}</p>
          )}
        </div>

        <p className="flex text-sm w-1/2 text-blue-700 mt-3 py-3 justify-evenly font-semibold mb-1">
          Ou
        </p>

        <div>
          <div className="w-full md:w-1/2 my-4">
            <label className="block text- font-medium text-blue-700 mb-1">
              Selecione um estado:
            </label>
            <SelectInt
              label="Estado"
              options={[]}
              optionsFull={estados}
              onChange={e => {
                setSelectedUF(e.target.value);
              }}
              placeholder="Selecione um estado"
              disabled={isPesquisaFeita || isCepMode}
            />
          </div>
          <div className="w-full md:w-1/2 my-4">
            <label className="block text- font-medium text-blue-700 mb-1">
              Selecione uma cidade:
            </label>
            <SelectInt
              label="Cidade"
              options={[]}
              optionsFull={city}
              onChange={e => {
                setSelectedCity(e.target.value);
              }}
              placeholder="Selecione uma cidade"
              disabled={isPesquisaFeita || isCepMode}
            />
          </div>
          <div className="w-full md:w-1/2 my-4">
            <label className="block font-medium text-blue-700 mb-1">
              Selecione um bairro:
            </label>
            <SelectInt
              label="Bairro"
              options={bairros.map(b => b.Nome)}
              optionsFull={bairros}
              onChange={e => {
                setSelectedBairro(e.target.value);
              }}
              placeholder="Selecione um Bairro"
              disabled={isPesquisaFeita || isCepMode}
            />
          </div>
        </div>
      </div>

      <div className="mt-6 flex justify-end">
        <button
          onClick={handleSearch}
          title="Clique para buscar dentistas"
          disabled={
            isSearchDone ||
            !(location || (selectedUF && selectedCity && selectedBairro)) ||
            !specialty
          }
          className={`flex items-center gap-2 px-6 py-3 rounded-xl text-white transition ${
            isSearchDone ||
            !(location || (selectedUF && selectedCity && selectedBairro)) ||
            !specialty
              ? 'bg-gray-300 text-white cursor-not-allowed'
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          BUSCAR
        </button>
        {loading && results.length === 0 && (
          <div className="ml-4 text-blue-600 flex items-center cursor-pointer">
            <PlanLoading />
            <span>Buscando resultados...</span>
          </div>
        )}
      </div>
      <div>
        {isPesquisaFeita && (
          <Button
            onClick={resetInterface}
            title="Clique para atualizar a tela e pesquisar novamente"
            className="px-4 py-3 rounded-lg text-white hover:bg-blue-400 transition cursor-pointer ml-4"
            sx={{
              backgroundColor: '#1e40af',
              color: '#fff',
              animation: `${pulse} 2s infinite`,
              '&:hover': {
                backgroundColor: '#60a5fa',
              },
            }}
          >
            Nova pesquisa
          </Button>
        )}
      </div>

      <div className="mt-6 flex flex-wrap lg:flex-nowrap justify-around w-full gap-4 h-full">
        {results.length > 0 && (
          <>
            <div className="flex-1 min-w-[300px] max-w-[600px] p-4 h-full rounded shadow-md">
              <div className="w-1/2 mb-4">
                <div
                  title="Clique para atualizar"
                  onClick={handleRefresh}
                  className=" flex items-center gap-2 rounded-md"
                >
                  <span className="text-sm text-blue-800 font-semibold">
                    Atualizar lista de dentistas
                  </span>
                  <Button
                    className="group p-2"
                    onClick={handleRefresh}
                    disabled={isRefreshing}
                  >
                    {isRefreshing ? (
                      <LoadingSpinnerIcon className="animate-spin w-5 h-5 text-blue-500" />
                    ) : (
                      <IconButton
                        sx={{
                          backgroundColor: '#fff',
                          animation: `${pulse} 2s infinite`,
                          '&:hover': {
                            backgroundColor: '#1e40a',
                          },
                        }}
                      >
                        <RefreshIcon />
                      </IconButton>
                    )}
                  </Button>
                </div>
              </div>
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <h3 className="text-lg font-sans font-bold mb-4 text-blue-800 mt-10 lg:mt-0">
                    Dentistas encontrados:
                  </h3>
                  <span className="text-lg font-sans font-bold mb-4 text-blue-800 mt-10 lg:mt-0">
                    {results.length}
                  </span>
                </div>
              </div>
              <ul className="space-y-3 max-h-[500px] overflow-y-auto pr-2">
                {results.map((dentista, index) => (
                  <li
                    key={index}
                    className="p-3 bg-gray-100 rounded border border-gray-200"
                  >
                    <div className="text-xs text-gray-500">
                      <div>
                        <span className="text-sm text-gray-500 mb-3 flex items-center gap-2">
                          <img
                            src="/assets/images/produtos-atendidos.png"
                            alt="Produtos Atendidos"
                            className="w-7 h-7"
                          />

                          <button
                            onClick={() => {
                              setIndiceDentistaSelecionado(index);
                              setOpen(true);
                            }}
                            className="px-2 py-2 text-black rounded-md hover:bg-blue-100"
                          >
                            Produtos Atendidos
                          </button>
                        </span>
                      </div>
                      <span
                        role="img"
                        aria-label="Ir ao mapa"
                        title="Ir ao mapa"
                      >
                        <ArrowRight
                          onClick={() => handleSetMapFocus(dentista)}
                          className="ml-auto cursor-pointer rounded-sm bg-sky-700 text-white mt-2 p-1 w-6 h-6 hover:bg-blue-300 transition"
                        />
                      </span>
                    </div>

                    <p className="font-semibold text-blue-900">
                      🦷 {dentista.nome}
                    </p>

                    <p className="text-sm text-gray-700">
                      <strong>Segmentação Assistencial:</strong> ODONTÓLOGICA
                    </p>

                    <p className="text-sm text-gray-700">
                      <strong>Tipo de estabelecimento:</strong>{' '}
                      {dentista?.cnpj && dentista.cnpj.trim() !== ''
                        ? 'Pessoa Jurídica'
                        : 'Pessoa Física'}
                    </p>

                    <p className="text-sm text-gray-700">
                      <strong>CNPJ:</strong>{' '}
                      {dentista?.cnpj && dentista.cnpj.trim() !== ''
                        ? formatarCNPJ(dentista.cnpj)
                        : 'Não informado'}
                    </p>

                    <p className="text-sm text-gray-700">
                      <strong>Razão Social:</strong>{' '}
                      {dentista.razaoSocial || 'Não informado'}
                    </p>
                    <br />

                    <p className="text-sm text-gray-700">
                      <strong>Endereço:</strong> 📍 {dentista.endereco}
                    </p>

                    <p className="text-sm text-gray-700">
                      <strong>Telefone:</strong> 📞 {dentista.telefone}
                    </p>

                    <p className="text-sm text-gray-700">
                      <strong>Bairro:</strong> {dentista.local}
                    </p>

                    <p className="text-sm text-gray-700">
                      <strong>Cidade:</strong> {dentista.municipio} -{' '}
                      {dentista.uf}
                    </p>

                    <p className="text-sm text-gray-700">
                      <strong>CEP:</strong> {dentista.cep}
                    </p>
                    <br />

                    <p className="text-sm text-gray-700">
                      <strong>Especialidade(s) atendida(s):</strong>{' '}
                      {dentista.especialidade}
                    </p>
                    <br />
                    {dentista.qualiss.length > 0 && (
                      <ul>
                        <div>
                          <strong className="text-sm text-gray-700">
                            Títulos:
                          </strong>
                        </div>
                        {dentista.qualiss.map((q, idx) => {
                          const letra = getLetraEspecialidade(q);
                          return (
                            <li
                              key={idx}
                              className="flex items-center gap-2 text-sm"
                            >
                              {letra && (
                                <>
                                  <span className="bg-blue-100 text-blue-800 px-1 py-1 rounded-full text-xs">
                                    {q.nomeEspecialidade}
                                  </span>
                                  <img
                                    src={letraIcones[letra]}
                                    alt={`Letra ${letra}`}
                                    title={`Especialidade: ${letra}`}
                                    className="w-5 h-5"
                                  />
                                </>
                              )}
                              <span className="bg-blue-100 text-black px-1 py-1 rounded-full text-xs">
                                ({q.Descricao})
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="relative">
              {open && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white w-[800px] max-h-[80vh] rounded shadow-lg overflow-hidden flex flex-col">
                    {/* Cabeçalho */}
                    <div className="bg-blue-800 text-white px-4 py-2 flex justify-between items-center">
                      <h2 className="text-lg font-semibold">
                        Produtos Atendidos
                      </h2>
                      <button
                        onClick={() => setOpen(false)}
                        className="text-white font-bold text-xl hover:text-gray-300"
                      >
                        ×
                      </button>
                    </div>

                    {/* Conteúdo */}
                    <div className="p-4 overflow-auto">
                      <p>
                        <strong>Clínica:</strong> {dentistaSelecionado?.nome}
                      </p>
                      <p className="text-sm text-gray-700 mb-2 mt-2">
                        PRODUTOS:
                      </p>

                      <table className="w-full border-collapse border border-gray-300 text-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="border border-gray-300 p-2 text-left">
                              Registro
                            </th>
                            <th className="border border-gray-300 p-2 text-left">
                              Nome
                            </th>
                            <th className="border border-gray-300 p-2 text-left">
                              Tipo de Contratação
                            </th>
                            <th className="border border-gray-300 p-2 text-left">
                              Abrangência Geográfica
                            </th>
                            <th className="border border-gray-300 p-2 text-left">
                              Segmentação Assistencial
                            </th>
                            <th className="border border-gray-300 p-2 text-left">
                              Situação
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {produtos.map(item => (
                            <tr key={item.idClassificacao}>
                              <td className="border border-gray-300 p-2">
                                {item.codigoAns}
                              </td>
                              <td className="border border-gray-300 p-2">
                                {item.descricao}
                              </td>
                              <td className="border border-gray-300 p-2">
                                {mapTipoContratacao[item.tipoContratacao] ||
                                  item.tipoContratacao}
                              </td>
                              <td className="border border-gray-300 p-2">
                                {mapAbrangencia[item.idAbrangencia] ||
                                  item.idAbrangencia}
                              </td>
                              <td className="border border-gray-300 p-2">
                                ODONTOLÓGICA
                              </td>
                              <td className="border border-gray-300 p-2">
                                {mapStatus[item.status] || 'DESCONHECIDO'}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex-1 w-full  mt-4">
              <h3 className="text-lg font-sans font-bold mb-4 text-blue-800 mt-10 lg:mt-0">
                Localização no mapa:
              </h3>
              <SimpleMap
                markers={results.map((d, index) => ({
                  id: String(index),
                  name: d.nome,
                  position: { lat: d.latitude, lng: d.longitude },
                  description: d.especialidade,
                  endereco: d.endereco,
                  telefone: d.telefone,
                }))}
                selectedMarkerId={focusedMarkerId}
                centerOverride={mapCenter}
              />
              <div className="flex justify-center gap-4 mt-4">
                <div className="flex items-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-black font-semibold px-2 py-1 rounded-full shadow-md">
                  <Button
                    className="flex items-center gap-2"
                    onClick={() => {
                      if (dentistaSelecionado) {
                        handleOpenWaze(
                          dentistaSelecionado.latitude,
                          dentistaSelecionado.longitude,
                        );
                      } else {
                        toast.error('Selecione um dentista no mapa.');
                      }
                    }}
                  >
                    <img
                      src="/assets/images/waze-logo.svg"
                      alt="Waze"
                      className="w-10 h-10"
                    />
                    Abrir no Waze
                  </Button>
                </div>
                <div className="flex items-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-black font-semibold px-2 py-1 rounded-full shadow-md">
                  <Button
                    className="flex items-center gap-2"
                    onClick={() => {
                      if (dentistaSelecionado) {
                        handleOpenUber(
                          dentistaSelecionado.latitude,
                          dentistaSelecionado.longitude,
                        );
                      } else {
                        toast.error('Selecione um dentista no mapa.');
                      }
                    }}
                  >
                    <img
                      src="/assets/images/uber-logo.svg"
                      alt="Uber"
                      className="w-10 h-10"
                    />
                    Abrir no Uber
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {results.length > 0 && (
        <div className="mt-4 flex justify-center items-center w-100 h-100">
          <img
            src="/assets/images/legenda-ans.png"
            alt="Legenda ANS"
            className="w-100 h-100"
          />
        </div>
      )}
    </div>
  );
};
export default Pesquisa;
